var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordShown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 16.9C9.50428 16.9 7.48828 14.8 7.48828 12.2C7.48828 9.6 9.50428 7.5 12.0003 7.5C14.4963 7.5 16.5123 9.6 16.5123 12.2C16.5123 14.8 14.4963 16.9 12.0003 16.9ZM12.0003 9.5C10.5603 9.5 9.40828 10.7 9.40828 12.2C9.40828 13.7 10.5603 14.9 12.0003 14.9C13.4403 14.9 14.5923 13.7 14.5923 12.2C14.5923 10.7 13.4403 9.5 12.0003 9.5Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.4C7.2 19.4 3.072 17 0.384 12.7L0 12.2L0.384 11.7C3.072 7.4 7.2 5 12 5C16.8 5 20.928 7.4 23.616 11.7L24 12.2L23.616 12.7C20.928 17.1 16.8 19.4 12 19.4ZM2.304 12.2C4.608 15.6 8.064 17.4 12 17.4C15.936 17.4 19.296 15.6 21.696 12.2C19.392 8.8 15.936 7 12 7C8.064 7 4.608 8.9 2.304 12.2Z",
    fill: "#CECECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShown);
export default __webpack_public_path__ + "static/media/password-shown.1c0d39efe5f0fbd0c34eb6619934bf6f.svg";
export { ForwardRef as ReactComponent };